import ImagePreloader from "../Elements/Preloaders/ImagePreloader";
import Urgent from "../Elements/Badges/Urgent";
import Premium from "../Elements/Badges/Premium";
import {LocationMarkerIcon} from "@heroicons/react/solid";
import HitDetails from "./HitDetails";
import classNames from "classnames";

const VerticalHit = ({ hit, props }) => {
    const {
        option_urgent,
        option_highlighting_active,
        address_postal_code,
        link, image_path,
        address_locality,
        type,
        readable_period,
        speciality,
        readable_price,
        partner_name,
        partner_picto,
    } = hit;

    return (
        <a href={link} className={classNames('text-gray-600 group', props?.class)} tabIndex={0}>
            <div className={'relative h-24 bg-gray-50 rounded-md overflow-hidden'}>
                {
                    image_path ?
                        <ImagePreloader
                            delay={150}
                            src={image_path}
                            className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-1000"
                        />
                        : null
                }

                {
                    partner_name ? <div className="absolute top-2 right-2"><img src={partner_picto} alt={partner_name} className="w-12"/></div> : ''
                }

                <div className={'absolute top-1 right-2'}>
                    <div className={'inline-flex gap-2'}>
                        {option_urgent ? <Urgent /> : ''}
                        {option_highlighting_active ? <Premium /> : ''}
                    </div>
                </div>
            </div>

            <div className={'p-2 flex flex-col justify-between gap-2'}>
                <div>
                    <div className="text-indigo-800 group-hover:text-indigo-700 text-lg font-bold font-title">
                        {speciality}
                    </div>
                    <div className={'flex items-center gap-1 text-sm'}>
                        <LocationMarkerIcon className={'w-4 h-4 group-hover:text-indigo-700'} />
                        <span>{address_locality} {address_postal_code ? '(' + address_postal_code + ')' : null}</span>
                    </div>
                </div>

                <HitDetails {...{ type, readable_period, readable_price }}/>
            </div>
        </a>
    )
}

export default VerticalHit